import React, { type ReactElement } from "react";
import { ArrowIcon, Button } from "@olivahealth/oli-ui";
import { useRouter } from "next/router";
import cx from "classnames";
import useSmallScreenDetection from "../../hooks/useSmallScreenDetection";

interface DarkModePageLayoutProps {
  className?: string;
  children: React.ReactNode;
  showBackButton?: boolean;
  fullWidth?: boolean;
  rightContent?: React.ReactNode;
  variant?: "flow" | "fill";
  overflow?: "auto" | "hidden" | "unset";
}

export function DarkModePageLayout({
  className,
  children,
  showBackButton = false,
  fullWidth = false,
  rightContent,
  variant = "flow",
  overflow = "auto",
}: DarkModePageLayoutProps): ReactElement {
  const { back } = useRouter();
  const isMobile = useSmallScreenDetection();

  const hasHeader = showBackButton || rightContent;
  const heightClass = variant === "fill" ? "h-full" : "";
  return (
    <div
      className={cx(
        "bg-[radial-gradient(ellipse_at_top_right,#5C42A4_0%,#1F1841_50%)]",
        {
          "min-h-screen": !isMobile && overflow !== "unset",
          "min-h-[calc(100vh-89px)]": isMobile && overflow !== "unset",
          "overflow-auto": overflow === "auto",
          "overflow-hidden": overflow === "hidden",
          "overflow-unset min-h-auto": overflow === "unset",
        },
        heightClass,
        className,
      )}
    >
      <div
        className={cx(`px-4 md:px-12 ${heightClass}`, {
          "max-w-6xl mx-auto py-20": !fullWidth,
          "max-w-full py-2": fullWidth,
        })}
      >
        {hasHeader && (
          <div className="flex items-center justify-between mb-6">
            {showBackButton ? (
              <Button onClick={back} variant="transparent" size="xs">
                <ArrowIcon direction="left" color="white" size={28} />
              </Button>
            ) : (
              <span />
            )}
            {rightContent ? <div>{rightContent}</div> : <span />}
          </div>
        )}
        {children}
      </div>
    </div>
  );
}
